const translations = {
    pending: 'Pending'
};

export default translations;
